import { IsNotEmpty, MaxLength, IsEmail, IsOptional, IsString, MinLength } from 'class-validator';

export class ProfileEditDTO {

    @IsNotEmpty()
    @IsString()
    @MaxLength(50)
    firstName: string;

    @IsNotEmpty()
    @IsString()
    @MaxLength(50)
    lastName: string;

    @IsNotEmpty()
    @IsEmail()
    email: string;

    @IsOptional()
    @IsString()
    @MaxLength(50)
    phone: string;

    @IsOptional()
    @IsString()
    @MaxLength(50)
    cellPhone: string;

    @IsOptional()
    @IsString()
    @MaxLength(50)
    image: string;

    @IsOptional()
    @IsString()
    @MinLength(20)
    @MaxLength(20)
    verificationCode?: string;

}
